var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8571 23.7143V15.6571C46.8571 14.663 46.0513 13.8571 45.0571 13.8571H4M46.8571 23.7143V35.2C46.8571 36.1941 46.0513 37 45.0571 37H43.0857C42.0916 37 41.2857 36.1941 41.2857 35.2V33.2286C41.2857 32.2345 40.4798 31.4286 39.4857 31.4286H8.37143C7.37732 31.4286 6.57143 32.2345 6.57143 33.2286V35.2C6.57143 36.1941 5.76554 37 4.77143 37H2.8C1.80589 37 1 36.1941 1 35.2V23.7143M46.8571 23.7143H1M1 23.7143V15.6571C1 14.663 1.80589 13.8571 2.8 13.8571H4M4 13.8571V2.8C4 1.80589 4.80589 1 5.8 1H42.0571C43.0513 1 43.8571 1.80589 43.8571 2.8V13.4286",
    stroke: "white",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28613 13.4286V8.8C8.28613 7.80589 9.09202 7 10.0861 7H20.629C21.6231 7 22.429 7.80589 22.429 8.8V13.8571",
    stroke: "white",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4287 13.4286V8.8C25.4287 7.80589 26.2346 7 27.2287 7H37.7716C38.7657 7 39.5716 7.80589 39.5716 8.8V13.8571",
    stroke: "white",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBedWhite);
export default __webpack_public_path__ + "static/media/iconBedWhite.65ad908d081c370c57bb379e26ddb408.svg";
export { ForwardRef as ReactComponent };